<template>
    <div style="width:100%;display:flex;">
        <el-select v-model="provice" placeholder="请选择" style="width:60px" filterable @change="selectChange">
            <el-option
            v-for="(item,index) in proviceList"
            :key="index"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <div style="flex:1;padding-left:15px">
            <el-input style="width:100%" placeholder="请输入车牌号码" v-model="carno" @change="selectChange" />
        </div>
    </div>
</template>
<script>
export default {
    props:{
        allcarno:{
            type:String,
            default:'',
        }
    },
    watch:{
        allcarno(val){
            this.allcarno = val.replace(/\s+/g, "")
            this.provice = this.allcarno ? this.allcarno.substring(0,1):'浙'
            this.carno = this.allcarno ? this.allcarno.substring(1) : ''
        }
    },
    data(){
        return{
            provice: this.allcarno ? this.allcarno.substring(0,1):'浙',
            carno: this.allcarno ? this.allcarno.substring(1) : '',
            proviceList: [
                "京",
                "津",
                "渝",
                "沪",
                "冀",
                "晋",
                "辽",
                "吉",
                "黑",
                "苏",
                "浙",
                "皖",
                "闽",
                "赣",
                "鲁",
                "豫",
                "鄂",
                "湘",
                "粤",
                "琼",
                "川",
                "贵",
                "云",
                "陕",
                "甘",
                "青",
                "蒙",
                "桂",
                "宁",
                "新",
                "藏",
                "使",
                "领",
                "警",
                "学",
                "港",
                "澳",
            ]
        }
    },
    methods:{
        selectChange(){
            this.$emit('changeProvice',this.provice+this.carno)
        }
    }
}
</script>

